import { NPCs } from "../content/bestiary";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Typography, Chip, Box, Stack, Tab, Tabs, AccordionProps, AccordionSummaryProps, styled, Rating } from "@mui/material"
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShieldIcon from '@mui/icons-material/Shield';
import ColorizeIcon from '@mui/icons-material/Colorize';
import { BodyStat, SharpnesStat, MindStat, SoulStat } from "../_/components/Stats";
import Divider from '@mui/material/Divider';

export const Enemy = ({ enemy }: { enemy: NPCs }) => (
    <>
    {/* <Typography>{enemy.name}</Typography> */}
    
    <Divider/>
    <EnemyDetails enemy={enemy} />
    </>
);

const EnemyDetails = ({ enemy }: { enemy: NPCs }) => (
    <>
        <Stack spacing={1} direction="column" >
            <Typography variant="h6" gutterBottom>
                {enemy.name}
            </Typography>   
            <Stack direction="row" spacing={2}>
                <Stack direction="column">
                    <Typography component="legend">Ciało</Typography>
                    <BodyStat  value={enemy.body} disabled/>
                </Stack>
                <Stack direction="column">
                    <Typography component="legend">Ostrość</Typography>
                    <SharpnesStat value={enemy.sharpnes} disabled/>
                </Stack>
                <Stack direction="column">
                    <Typography component="legend">Umysł</Typography>
                    <MindStat value={enemy.mind} disabled/>
                </Stack>
                <Stack direction="column">
                    <Typography component="legend">Dusza</Typography>
                    <SoulStat value={enemy.spirit} disabled/>
                </Stack>
            </Stack>

            <Stack direction="row" spacing={2}>
                <Stack direction="row" spacing={2}>
                    <FavoriteIcon /> <Typography component="legend">{enemy.hp}</Typography> </Stack>
                <Stack spacing={2} direction="row"><ColorizeIcon /> <Typography component="legend">{enemy.dmg}</Typography> </Stack>
                {enemy.armor !== 0 && <Stack spacing={2} direction="row"><ShieldIcon />  <Typography component="legend">{enemy.armor}</Typography></Stack>}
            </Stack>

            {enemy.feats.length > 0 &&
                <>
                    <Typography variant="h6" gutterBottom>
                        Atuty
                    </Typography>
                    <Typography variant="body1" gutterBottom paddingBottom={'32px'}>
                        {enemy.feats.map(feat => <Chip label={feat} variant="outlined" sx={{ margin: "2px" }} />)}
                    </Typography>
                </>
            }

            {enemy.special.length > 0 &&
                <>
                    <Typography variant="h6" gutterBottom>
                        Specjalne zdolności
                    </Typography>
                    <Typography variant="body1" gutterBottom paddingBottom={'32px'}>
                        {enemy.special.map(spec => <Chip label={spec} variant="outlined" sx={{ margin: "2px" }} />)}
                    </Typography>
                </>
            }
        </Stack>
        <Typography gutterBottom marginBottom={"16px"} align="justify">

        </Typography>
    </>
)

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));